import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['access_token'] = localStorage.getItem("user_token");
axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: 'https://shopapi.hbcygc.net/api/sgp/',
  // 超时
  timeout: 1000 * 60 * 3
});

service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息

  if(res.data.code != 200){
    console.log(res.data.message);
  }
  return res.data;
}, error => {

});



export default service